import { render, staticRenderFns } from "./Landfills.vue?vue&type=template&id=e1eb1c8c&scoped=true&"
import script from "./Landfills.vue?vue&type=script&lang=js&"
export * from "./Landfills.vue?vue&type=script&lang=js&"
import style0 from "./Landfills.vue?vue&type=style&index=0&id=e1eb1c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1eb1c8c",
  null
  
)

export default component.exports